// tslint:disable
export var ExternalIdType;
(function (ExternalIdType) {
    // UNKN
    ExternalIdType[ExternalIdType["UNKNOWN"] = 0] = "UNKNOWN";
    // MBRID
    ExternalIdType[ExternalIdType["MEMBERID"] = 1] = "MEMBERID";
    // SSN
    ExternalIdType[ExternalIdType["SOCIALSECURITYNUMBERSSN"] = 2] = "SOCIALSECURITYNUMBERSSN";
    // EIN
    ExternalIdType[ExternalIdType["FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN"] = 3] = "FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN";
    // DL
    ExternalIdType[ExternalIdType["DRIVERSLICENSENUMBER"] = 4] = "DRIVERSLICENSENUMBER";
    // DEA
    ExternalIdType[ExternalIdType["DEANUMBER"] = 5] = "DEANUMBER";
    // NPI
    ExternalIdType[ExternalIdType["NPINUMBER"] = 6] = "NPINUMBER";
    // GRP
    ExternalIdType[ExternalIdType["GROUPID"] = 7] = "GROUPID";
    // EMP
    ExternalIdType[ExternalIdType["EMPLOYEEID"] = 8] = "EMPLOYEEID";
    // STLIC
    ExternalIdType[ExternalIdType["STATELICENSENUMBER"] = 9] = "STATELICENSENUMBER";
    // PCN
    ExternalIdType[ExternalIdType["PROCESSORCONTROLLERNUMBER"] = 10] = "PROCESSORCONTROLLERNUMBER";
    // BIN
    ExternalIdType[ExternalIdType["BANKIDENTIFICATIONNUMBER"] = 11] = "BANKIDENTIFICATIONNUMBER";
    // MEDID
    ExternalIdType[ExternalIdType["MEDICALID"] = 12] = "MEDICALID";
    // ISGV
    ExternalIdType[ExternalIdType["ISGOVERNMENT"] = 13] = "ISGOVERNMENT";
    // ARXCN
    ExternalIdType[ExternalIdType["ASSISTRXCASENUMBER"] = 14] = "ASSISTRXCASENUMBER";
    // ISBENPL
    ExternalIdType[ExternalIdType["ISMEDICALBENEFIT"] = 15] = "ISMEDICALBENEFIT";
    // COVSTDT
    ExternalIdType[ExternalIdType["COVERAGESTARTDATE"] = 16] = "COVERAGESTARTDATE";
    // COVENDDT
    ExternalIdType[ExternalIdType["COVERAGEENDDATE"] = 17] = "COVERAGEENDDATE";
    // PLYR
    ExternalIdType[ExternalIdType["PLANYEAR"] = 18] = "PLANYEAR";
    // VirmedicaPracId
    ExternalIdType[ExternalIdType["VirmedicaPraticeID"] = 19] = "VirmedicaPraticeID";
    // VirmedicaLocId
    ExternalIdType[ExternalIdType["VirmedicaLocationID"] = 20] = "VirmedicaLocationID";
    // VirmedicaPrvdId
    ExternalIdType[ExternalIdType["VirmedicaProviderID"] = 21] = "VirmedicaProviderID";
    // VirmedicaHCPPrvdId
    ExternalIdType[ExternalIdType["VirmedicaHCPProviderID"] = 22] = "VirmedicaHCPProviderID";
    // VMMasterPayerID
    ExternalIdType[ExternalIdType["VirmedicaMasterPayerID"] = 23] = "VirmedicaMasterPayerID";
    // VMPayerID
    ExternalIdType[ExternalIdType["VirmedicaPayerID"] = 24] = "VirmedicaPayerID";
    // MaxRTEPayorID
    ExternalIdType[ExternalIdType["MaxRTEPayorID"] = 25] = "MaxRTEPayorID";
    // PTAN
    ExternalIdType[ExternalIdType["ProviderTransactionAccessNumber"] = 26] = "ProviderTransactionAccessNumber";
})(ExternalIdType || (ExternalIdType = {}));
ExternalIdType['VIRMEDICAPRATICEID'] = 19;
ExternalIdType['VIRMEDICALOCATIONID'] = 20;
ExternalIdType['VIRMEDICAPROVIDERID'] = 21;
ExternalIdType['VIRMEDICAHCPPROVIDERID'] = 22;
ExternalIdType['VIRMEDICAMASTERPAYERID'] = 23;
ExternalIdType['VIRMEDICAPAYERID'] = 24;
ExternalIdType['MAXRTEPAYORID'] = 25;
ExternalIdType['PROVIDERTRANSACTIONACCESSNUMBER'] = 26;
//# sourceMappingURL=ExternalIdType.js.map